/**
 * Resume.jsx
 * Presents Robert's résumés — tailored for leadership, engineering, or data roles.
 */

import {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import config from '#config/server';

const resumes = [
	{ key: 'leadership',  label: 'Leadership',  sub: 'VP / Director of IT',   file: 'robert-parham-resume-leadership-2026-08-11.pdf' },
	{ key: 'engineering', label: 'Engineering', sub: 'Full-Stack Engineer',   file: 'robert-parham-resume-engineering-2026-08-11.pdf' },
	{ key: 'data',        label: 'Data & AI',   sub: 'ML / Data Engineering', file: 'robert-parham-resume-data-2026-08-11.pdf' },
	{ key: 'devops',        label: 'DevOps',   sub: 'CI/CD & Infrastructure', file: 'robert-parham-resume-devops-2026-08-11.pdf' },
	{ key: 'pm',        label: 'Project Management',   sub: 'PM / Strategy', file: 'robert-parham-resume-pm-2026-08-11.pdf' },
];

export function Resume(){
	const [active, setActive] = useState('leadership');
	const current = resumes.find(r => r.key === active);
	const url = `${config.base_url}assets/${current.file}`;

	return (<section className="resume-wrap">
		<div className="section-head">
			<span className="eyebrow">Résumé</span>
			<h2>Choose the lens that fits the role</h2>
		</div>

		<div className="resume-switch">
			{resumes.map(r => (
				<button key={r.key} className={r.key === active ? 'active' : ''} onClick={()=>setActive(r.key)}>
					{r.label}
					<span className="sub">{r.sub}</span>
				</button>
			))}
		</div>

		<div className="resume-actions">
			<a className="btn btn-outline-navy btn-sm me-2" href={url} download>
				<FontAwesomeIcon icon={faDownload} /> Download PDF
			</a>
			<a className="btn btn-outline-navy btn-sm" href={url} target="_blank" rel="noopener">
				<FontAwesomeIcon icon={faArrowUpRightFromSquare} /> Open in new tab
			</a>
		</div>

		<iframe key={active} className="resume-frame" src={`${url}#view=FitH`} title={`${current.label} résumé`} />
	</section>);
}
